import React from "react"
import { Link } from "gatsby"
import '../components/Team.css'

import SEO from "../components/seo"
import '../components/theme.js'


const SecondPage = () => (
  <>
    <SEO title="Page two" />
    <div className="Acknowledgements">
    <div className="CloseButton">
      <Link to="/"><img src={require('../images/button_close.svg')} /></Link>
    </div>
      <div className="FYI">
        <h1>Acknowledgements</h1>
        <div className="ContentArea">
          <h3>RED Design Darkmode Project Thinking</h3>
          <p>在项目初始阶段，由于产品形态和阶段以及公司的工作方式的差异性，需要各个部们就整个项目的成本、必要性做一定的说明，可以将设计说明文档和适配方案进行同步。由于大体上是从设计侧出发做这件事情，所以在某些程度上，需要项目的设计负责人做好各阶段的信息同步和设计决策，各部们在有效沟通的基础上协作来进行整体项目的推进工作。</p><br />
          <p>在整个项目的过程当中，需要前期对项目周期、项目排期和固定的研发讨论明确下来，由于涉及到 App 全局性的调整，对于项目过程中遇到的走查环节、测试环节、修复环节中出现的问题，需要时刻注意并给出相应的解决方案。</p><br />
          <p>在 Darkmode 的适配上，由于方案的特殊性，所以组件和色彩规定的完整性相对显得比较重要，制定符合公司产品的 Design Guideline 显得尤为重要，通过组件的复用和交付方式的改善，可以在一定程度上保证二种模式下的适配和走查的高效性。</p><br />
          <h4>Special Thanks to</h4>
          <span>RED DESIGN TEAM</span>
          </div>
      </div>
    </div>
 
</>    
)

export default SecondPage
